import React from "react";

import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

const AuthCardBanner = ({
  icon = false,
  children,
}: {
  icon?: React.ReactNode | false;
  children: React.ReactNode;
}) => {
  return (
    <Alert
      severity="warning"
      icon={icon}
      sx={{
        width: "100%",
        color: "chart.orange.dark",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="bodyPrimaryReg"
        sx={{
          fontSize: "0.875rem",
          color: "warning.main",
          fontWeight: 500,
          textAlign: { xxs: "left", mobile: "center" },
          width: "100%",
        }}
      >
        {children}
      </Typography>
    </Alert>
  );
};

export default AuthCardBanner;
